/*
* Copyright © 2019 Insticator, Inc. All Rights Reserved.
*
* CONFIDENTIALITY NOTICE: THIS SOFTWARE CONTAINS CONFIDENTIAL INFORMATION OF
* INSTICATOR, INC. USE, DISCLOSURE OR REPRODUCTION IS PROHIBITED WITHOUT THE PRIOR
* EXPRESS WRITTEN PERMISSION OF INSTICATOR, INC.
*/

/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// STYLES
// (css-in-js, imported as JS from external file, turned into CSS via library used in utils)
import styles from 'components/content/shared/story/storyurl/storyurl_styles';
import { createStyles } from 'utils/styles';
import externalLinkAltSolid from 'icons/external-link-alt-solid.svg'
import Icon from 'components/shared/icon/icon';
const sheet = createStyles(styles, { link: true });

/* ========== ~~~~~~~~~~ QUESTION SET ~~~~~~~~~~ ========== */
const StoryUrl = props => {
  return (
    <div className={`${sheet.classes.storyurl} storyurl`}>
      <a className={'storylink'} onClick={() => props.handleClick('readMe')}>
        <p className={'linktext'} >{props.text}</p>
        <Icon svg={externalLinkAltSolid} size={13.3}/>
      </a>
    </div>
  );
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default StoryUrl;